import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { UpdateClientDiscountPayload } from "../../payload/UpdateClientDiscount/UpdateClientDiscountPayload";

const updateClientDiscountFetch = (state: ClientsState, action: PayloadAction<UpdateClientDiscountPayload>) => {
    state.isLoading = true;
}

export default updateClientDiscountFetch;